import { Chip, type ChipProps } from '@mui/material';

interface TierBadgeProps {
  tier: string;
}

function getTierColor(tier: string): ChipProps['color'] {
  switch (tier) {
    case 'Tier 4':
      return 'error';
    case 'Tier 3':
      return 'warning';
    case 'Tier 2':
      return 'primary';
    case 'Tier 1':
      return 'success';
    default:
      return 'default';
  }
}

export function TierBadge({ tier }: TierBadgeProps) {
  return (
    <Chip
      label={tier}
      color={getTierColor(tier)}
      size="small"
      variant="outlined"
      sx={{ minWidth: 64, justifyContent: 'center' }}
    />
  );
}
